// extracted by mini-css-extract-plugin
export default {"disableScroll":"SZ0sJ8","menu":"FWUQsr","active":"BCF5Gz","overlay":"MTBQJj","closeIcon":"yS7ypr","innerIcon":"uYU0uY","menuItems":"VwS5sq"};